// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"style_searchBar__ji3sO"};